import React, { useState } from "react";

/** Process-flow PNGs served from public/use-cases/ (user-provided per diagram). */
export default function ProcessFlowImage({ src, alt }) {
  const [err, setErr] = useState(false);

  if (err) {
    return (
      <div className="flow-diagram-fallback">Process diagram not available.</div>
    );
  }

  return (
    <img
      className="flow-diagram-img"
      src={src}
      alt={alt}
      loading="lazy"
      decoding="async"
      onError={() => setErr(true)}
    />
  );
}

